import { u, styled } from '../../../shared/theming-sc'

const HeaderBar = styled.div`
    padding: ${u.getSpacing('medium')}px ${u.getSpacing('small')}px;
    border-bottom: 1px solid ${u.getColor('greyLightest')};
    margin-bottom:  0;
    overflow: auto;
    position: relative;

    ${u.media.greaterThan('lg')`
       padding: ${u.getSpacing('medium')}px ${u.getSpacing('large')}px;
     `};
`

const HeaderContentBlock = styled.div`
    width: 40%;
    float: left;

    @media(max-width: ${p => ('1280px')}) {
      width: 100%;
    }
`

const HeaderSummary = styled.p`
    font-size: ${u.getFontSize('sm')};
    font-weight: bold;
    font-family: Arial;
    text-transform: uppercase;
    letter-spacing: 2px;
    margin-bottom:  ${u.getSpacing('tiny')}px;
`

const HeaderTitle = styled.h1`
    font-weight: 900;
    font-size: ${u.getFontSize('lg')};
`

export {
  HeaderTitle,
  HeaderContentBlock,
  HeaderBar,
  HeaderSummary
}
